define.alias("ember-power-select/components/power-select/trigger", "preview-grid/components/power-select/trigger");